import axios from "axios";

const API = `${
  process.env.REACT_APP_API_URL || "http://localhost:5001"
}/api/performance-review`;

export const createPrPeriodApi = (payload) =>
  axios.post(`${API}/periods`, payload);
export const generatePrPeriodApi = (id) =>
  axios.post(`${API}/periods/${id}/generate`, null);
export const finalisePrPeriodApi = (id) =>
  axios.post(`${API}/periods/${id}/finalise`, null);
export const reopenPrPeriodApi = (id) =>
  axios.post(`${API}/periods/${id}/reopen`, null);
export const adjustPrEmployeeApi = (id, employeeId, payload) =>
  axios.post(`${API}/periods/${id}/employee/${employeeId}/adjust`, payload);
export const waiveSundaysPrEmployeeApi = (id, employeeId, payload) =>
  axios.post(
    `${API}/periods/${id}/employee/${employeeId}/waive-sundays`,
    payload,
  );
export const updatePrConfigApi = (payload) =>
  axios.put(`${API}/config`, payload);
